export default "__VITE_ASSET__DjCeILT8__"